import React, { useContext, VFC } from 'react';

import classNames from 'classnames';
import { Text } from 'mintel-react-ui';

import {
  BlockBackgroundContext,
  PresentModeContext,
} from '../../utils/contexts';
import styles from './Title.scss';

type TitleProps = {
  content?: string;
  hidden?: boolean;
  centered?: boolean;
};

const Title: VFC<TitleProps> = ({
  content,
  hidden = false,
  centered = false,
}) => {
  const presentMode = useContext(PresentModeContext);
  const { darkBg } = useContext(BlockBackgroundContext);

  return (
    <div
      className={classNames(
        centered ? styles['block-title-centered'] : styles['block-title-left'],
        {
          [styles['present-mode']]: !!presentMode,
        },
      )}
    >
      {!hidden && content && (
        <Text.Heading3 darkBg={darkBg} underlineLinks>
          <h3 dangerouslySetInnerHTML={{ __html: content }} />
        </Text.Heading3>
      )}
    </div>
  );
};

export default Title;
